
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/banner/create",
      function () {
        return require("private-next-pages/banner/create.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/banner/create"])
      });
    }
  